import React, { Component } from "react";
import { Container, Row } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import DevicesTable from "../components/devices-list/DevicesTable"
import UserContext from '../contexts/UserContext'
export default class UsersList extends Component {

  static contextType = UserContext;

  constructor(props) {
    super(props);   
  }
  componentDidMount(){
    const user = this.context;
    console.log("Context: "+JSON.stringify(user));
  }


  render() {
    return (<Container fluid className="main-content-container px-4">
      {/* Page Header */}
    

      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title="Liste des appareils" subtitle="Tv Finder" className="text-sm-left" />

      </Row>
     
      <DevicesTable />

    </Container>);
  }
}

